Vue.asyncComponent('ak-progress-circular', {
    props: {
        size:{
            type: Number|String,
            default: 90
        },
        percentage:{
            type: Number
        }
    },
    model: {
        prop: 'percentage',
        event: 'change'
    }
}, 'layout/progress/ak-progress-circular.html');